import React from 'react'
import { Drawer } from 'antd'
import { useHistory, useParams } from 'react-router-dom'

import { useToggle, stringifyDate, useListData } from '../../modules'

import Receive from '../resusable/receive'
import { useSelector } from 'react-redux'

const ItemHistory = () => {
    const { id, store } = useParams()
    const { user } = useSelector(state => state.application)

    const [{ loading, error, fetch }, { list: history, data }, { Paginate, page = 1, limit = 100 }] = useListData('itemHistory', {
        id,
        store,
    }, { notify: true }, 'history')

    const hst = useHistory()

    const [visible, toggleVisible] = useToggle(true)

    const close = () => {
        toggleVisible()
        setTimeout(() => hst.goBack(), 300)
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button onClick={ close } className="text-white mr-2 bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
                </div>
            }
            width="40%">
            <header className="pb-4 border-b border-gray-100 flex justify-between items-center">
                <p className="font-extrabold text-3xl mb-0">Item History</p>
            </header>
            <Receive
                error={error}
                loading={loading}
                progress>
                <ul className="list-none m-0 p-0 mt-3">
                    {
                        history.map(record =>
                            <li className="mb-2">
                                <div className="flex items-center mb-1">
                                    <div className={`${record.bulkCount * record.containing > 0 ? 'bg-green-500' : 'bg-red-500'} rounded-full h-4 w-4 border-gray-200 border-2 z-10`}>
                                    </div>
                                    <div className="flex-1 ml-4 font-medium">{record.desc}</div>
                                </div>
                                <div className="ml-12">
                                    <p className="mb-1 mt-0 text-md">New Total: {record.total} {data?.item?.issuedIn} { record.total > 0 && record.desc.includes('Purchase') && `@ Ksh. ${record.bp}` }</p>
                                    <p className={ `${record.bulkCount * record.containing > 0 ? 'text-green-600' : 'text-red-500'} text-xs italic mb-0` }>{record.bulkCount * record.containing} {data?.item?.issuedIn}</p>
                                    {stringifyDate(record?.committedOn)}
                                    <p className="text-gray-500 mt-2 text-xs italic">Recorded by {record?.committedBy?.name}</p>
                                </div>
                            </li>
                        )
                    }
                </ul>
            </Receive>
            { Paginate }
        </Drawer>
    )
}

export default ItemHistory